import React, { useState, useEffect } from "react";
import '../../css/customBreadcrumbs.css';
import { useMobileMediaQuery, useTabletMediaQuery, useMobileBtnBackMediaQuery } from "../../utils";
import { Link, useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from "react-icons/fa6";
import { useDispatch, useSelector } from 'react-redux';
import { setStartSpend } from '../../features/onboardingData/onboardingUserData';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import IconMyMedisSvg from '../../assets/svg/iconMyMedisBreadcrumbs.svg';
import IconLeftSvg from '../../assets/svg/iconLeftBreadcrumbs.svg';

const CustomBreadcrumbs = (props) => {

    const {
        hasBtnBack = true,
        hasPadding = false,
        goHome = false,
        hasEarnBalance = false,
        hasMoviments = false,
        hasPartnerCatalog = false,
        hasReceberSaldo = false,
        hasGastarNoMarketplace = false,
        nomeparceiro = '',
    } = props;

    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isMobileBtnBack = useMobileBtnBackMediaQuery();
    const isStartSpend = useSelector((state) => state.onboardingUserData.isStartSpend);
    const dispatch = useDispatch();

    const handleGoBackClick = () => {
        navigate(-1);
        dispatch(setStartSpend(false));
    };

    const handleGoHomeClick = () => {
        navigate('/');
        dispatch(setStartSpend(false));
    };

    function handleClickNavList(event) {
        event.preventDefault();
    }

    const mainViewContainerCustomBreadcrumbs = hasPadding ? 
    ( isTablet ? 'mainViewContainerHasPaddingCustomBreadcrumbs' : ( isMobile ? 'mainViewContainerHasPaddingCustomBreadcrumbsTablet' : 'mainViewContainerHasPaddingCustomBreadcrumbsMobile' ) ) : 
    ( isTablet ? 'mainViewContainerCustomBreadcrumbs' : ( isMobile ? 'mainViewContainerCustomBreadcrumbsTablet' : 'mainViewContainerCustomBreadcrumbsMobile' ) );

    const handkeChangeMaxLength = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.slice(0, maxLength) + '...';
        }
        return text;
    };

    const containerCustomBreadcrumbsMobile = 
        (!hasEarnBalance && !hasPartnerCatalog && nomeparceiro.length === 0) ? 'containerCustomBreadcrumbsOneMobile' :
        ((hasEarnBalance && !hasPartnerCatalog && nomeparceiro.length === 0) || hasMoviments || hasReceberSaldo || hasGastarNoMarketplace) ? 'containerCustomBreadcrumbsTwoMobile' : 
        (hasEarnBalance && hasPartnerCatalog && nomeparceiro.length === 0) ? 'containerCustomBreadcrumbsThreeMobile' : 'containerCustomBreadcrumbsMobile'
    
    return (
        <div className={mainViewContainerCustomBreadcrumbs}>
            { isTablet ?
                <div className='containerCustomBreadcrumbs' role="presentation" >
                    <Breadcrumbs aria-label="breadcrumb" className='txtNavListCustomBreadcrumbs'>
                        <div className='redirectNavViewContainerCustomBreadcrumbs'>
                            <a href="https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/Home" target="_blank" rel="noopener noreferrer" className="linkStyleRedirectNavCustomBreadcrumbs">
                                <img className='medisUserMenuSvgIconNavListCustomBreadcrumbs' src={IconMyMedisSvg} alt="imagem" />
                                <div className='txtNavListCustomBreadcrumbs'>Minha Médis</div>
                            </a>
                        </div>
                        <Link to="/" className="linkStyleCustomBreadcrumbs">
                            <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                <div className='txtNavListCustomBreadcrumbs'>Carteira Virtual Médis</div>
                            </div>
                        </Link>
                        { hasMoviments &&
                            <Link to="/movimentos" className="linkStyleCustomBreadcrumbs">
                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                    <div className='txtNavListCustomBreadcrumbs'>Ver movimentos</div>
                                </div>
                            </Link>
                        }
                        { hasReceberSaldo &&
                            <Link to="/gastar-saldo/seguro" className="linkStyleCustomBreadcrumbs">
                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                    <div className='txtNavListCustomBreadcrumbs'>Receber saldo</div>
                                </div>
                            </Link>
                        }
                        { hasGastarNoMarketplace &&
                            <Link to="/gastar-saldo/marketplace" className="linkStyleCustomBreadcrumbs">
                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                    <div className='txtNavListCustomBreadcrumbs'>Gastar no marketplace</div>
                                </div>
                            </Link>
                        }
                        { hasEarnBalance &&
                            <Link to="/ganhar-saldo" className="linkStyleCustomBreadcrumbs">
                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                    <div className='txtNavListCustomBreadcrumbs'>Ganhar saldo</div>
                                </div>
                            </Link>
                        }
                        { hasPartnerCatalog &&
                            <Link to="/ganhar-saldo/parceiros/catalogo-de-parceiros" className="linkStyleCustomBreadcrumbs">
                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                    <div className='txtNavListCustomBreadcrumbs'>Ver parceiros</div>
                                </div>
                            </Link>
                        }
                        { nomeparceiro.length !== 0 &&
                            ( nomeparceiro.length > 15 ?
                                <>
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <div className='txtNavListCustomBreadcrumbs'>{handkeChangeMaxLength(nomeparceiro, 15)}</div>
                                    </div> 
                                    <div className='alertHoverInfoMainViewCustomBreadcrumbs'>
                                        <div className='mainViewAlerSmModalCustomBreadcrumbs'>
                                            <div className='CustomBreadcrumbs'>{nomeparceiro}</div>
                                        </div>
                                    </div>
                                </>
                            : 
                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                    <div className='txtNavListCustomBreadcrumbs'>{nomeparceiro}</div>
                                </div> 
                            )
                            
                        }
                    </Breadcrumbs>
                </div>
                : ( isMobile ? (
                    <div className='containerCustomBreadcrumbs' role="presentation" >
                        <Breadcrumbs aria-label="breadcrumb" className='txtNavListCustomBreadcrumbs'>
                            <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                <a href="https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/Home" target="_blank" rel="noopener noreferrer" className="linkStyleRedirectNavCustomBreadcrumbs">
                                    <img className='medisUserMenuSvgIconNavListCustomBreadcrumbs' src={IconMyMedisSvg} alt="imagem" />
                                    <div className='txtNavListCustomBreadcrumbs'>Minha Médis</div>
                                </a>
                            </div>
                            <Link to="/" className="linkStyleCustomBreadcrumbs">
                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                    <div className='txtNavListCustomBreadcrumbs'>Carteira Virtual Médis</div>
                                </div>
                            </Link>
                            { hasMoviments &&
                                <Link to="/movimentos" className="linkStyleCustomBreadcrumbs">
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <div className='txtNavListCustomBreadcrumbs'>Ver movimentos</div>
                                    </div>
                                </Link>
                            }
                            { hasReceberSaldo &&
                                <Link to="/gastar-saldo/seguro" className="linkStyleCustomBreadcrumbs">
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <div className='txtNavListCustomBreadcrumbs'>Receber saldo</div>
                                    </div>
                                </Link>
                            }
                            { hasGastarNoMarketplace &&
                                <Link to="/gastar-saldo/marketplace" className="linkStyleCustomBreadcrumbs">
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <div className='txtNavListCustomBreadcrumbs'>Gastar no marketplace</div>
                                    </div>
                                </Link>
                            }
                            { hasEarnBalance &&
                                <Link to="/ganhar-saldo" className="linkStyleCustomBreadcrumbs">
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <div className='txtNavListCustomBreadcrumbs'>Ganhar saldo</div>
                                    </div>
                                </Link>
                            }
                            { hasPartnerCatalog &&
                                <Link to="/ganhar-saldo/parceiros/catalogo-de-parceiros" className="linkStyleCustomBreadcrumbs">
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <div className='txtNavListCustomBreadcrumbs'>Ver parceiros</div>
                                    </div>
                                </Link>
                            }
                            { nomeparceiro.length !== 0 &&
                                ( nomeparceiro.length > 15 ?
                                    <>
                                        <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                            <div className='txtNavListCustomBreadcrumbs'>{handkeChangeMaxLength(nomeparceiro, 15)}</div>
                                        </div> 
                                        <div className='alertHoverInfoMainViewCustomBreadcrumbs'>
                                            <div className='mainViewAlerSmModalCustomBreadcrumbs'>
                                                <div className='CustomBreadcrumbs'>{nomeparceiro}</div>
                                            </div>
                                        </div>
                                    </>
                                : 
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <div className='txtNavListCustomBreadcrumbs'>{nomeparceiro}</div>
                                    </div> 
                                )
                                
                            }
                        </Breadcrumbs>
                    </div>
                    ) : (
                        <div className='mainContainerCustomBreadcrumbsMobile'>
                            { hasMoviments &&
                                <div className='goBackdMainViewContainerCustomBreadcrumbsMobile'>
                                    <div className='goBackBtnViewCustomBreadcrumbsMobile'>
                                        <button className='txtGoBackBtnCustomBreadcrumbsMobile'  type='button' onClick={ goHome ? handleGoHomeClick : handleGoBackClick} >
                                            <img className='goBackIconCustomBreadcrumbsMobile' src={IconLeftSvg} alt="imagem" />
                                        </button>
                                    </div>
                                </div>
                            }
                            { hasReceberSaldo &&
                                <div className='goBackdMainViewContainerCustomBreadcrumbsMobile'>
                                    <div className='goBackBtnViewCustomBreadcrumbsMobile'>
                                        <button className='txtGoBackBtnCustomBreadcrumbsMobile'  type='button' onClick={ goHome ? handleGoHomeClick : handleGoBackClick} >
                                            <img className='goBackIconCustomBreadcrumbsMobile' src={IconLeftSvg} alt="imagem" />
                                        </button>
                                    </div>
                                </div>
                            }
                            { hasGastarNoMarketplace &&
                                <div className='goBackdMainViewContainerCustomBreadcrumbsMobile'>
                                    <div className='goBackBtnViewCustomBreadcrumbsMobile'>
                                        <button className='txtGoBackBtnCustomBreadcrumbsMobile'  type='button' onClick={ goHome ? handleGoHomeClick : handleGoBackClick} >
                                            <img className='goBackIconCustomBreadcrumbsMobile' src={IconLeftSvg} alt="imagem" />
                                        </button>
                                    </div>
                                </div>
                            }
                            { hasEarnBalance &&
                                <div className='goBackdMainViewContainerCustomBreadcrumbsMobile'>
                                    <div className='goBackBtnViewCustomBreadcrumbsMobile'>
                                        <button className='txtGoBackBtnCustomBreadcrumbsMobile'  type='button' onClick={ goHome ? handleGoHomeClick : handleGoBackClick} >
                                            <img className='goBackIconCustomBreadcrumbsMobile' src={IconLeftSvg} alt="imagem" />
                                        </button>
                                    </div>
                                </div>
                            }
                            <div className={containerCustomBreadcrumbsMobile} role="presentation" >
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <a href="https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/Home" target="_blank" rel="noopener noreferrer" className="linkStyleRedirectNavCustomBreadcrumbs">
                                            <img className='medisUserMenuSvgIconNavListCustomBreadcrumbs' src={IconMyMedisSvg} alt="imagem" />
                                            <div className='txtNavListCustomBreadcrumbs'>Minha Médis</div>
                                        </a>
                                    </div>
                                    <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                        <div className='txtNavListCustomBreadcrumbs'>/</div>
                                    </div>
                                    <Link to="/" className="linkStyleCustomBreadcrumbs">
                                        <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                            <div className='txtNavListCustomBreadcrumbs'>Carteira Virtual Médis</div>
                                        </div>
                                    </Link>
                                    { hasMoviments &&
                                        <>
                                            <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                                <div className='txtNavListCustomBreadcrumbs'>/</div>
                                            </div>
                                            <Link to="/movimentos" className="linkStyleCustomBreadcrumbs">
                                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                                    <div className='txtNavListCustomBreadcrumbs'>Ver movimentos</div>
                                                </div>
                                            </Link>
                                        </>
                                    }
                                    { hasReceberSaldo &&
                                        <>
                                            <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                                <div className='txtNavListCustomBreadcrumbs'>/</div>
                                            </div>
                                            <Link to="/gastar-saldo/seguro" className="linkStyleCustomBreadcrumbs">
                                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                                    <div className='txtNavListCustomBreadcrumbs'>Receber saldo</div>
                                                </div>
                                            </Link>
                                        </>
                                    }
                                    { hasGastarNoMarketplace &&
                                        <>
                                            <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                                <div className='txtNavListCustomBreadcrumbs'>/</div>
                                            </div>
                                            <Link to="/gastar-saldo/marketplace" className="linkStyleCustomBreadcrumbs">
                                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                                    <div className='txtNavListCustomBreadcrumbs'>Gastar no marketplace</div>
                                                </div>
                                            </Link>
                                        </>
                                    }
                                    { hasEarnBalance &&
                                        <>
                                            <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                                <div className='txtNavListCustomBreadcrumbs'>/</div>
                                            </div>
                                            <Link to="/ganhar-saldo" className="linkStyleCustomBreadcrumbs">
                                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                                    <div className='txtNavListCustomBreadcrumbs'>Ganhar saldo</div>
                                                </div>
                                            </Link>
                                        </>
                                    }
                                    { hasPartnerCatalog &&
                                        <>
                                            <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                                <div className='txtNavListCustomBreadcrumbs'>/</div>
                                            </div>
                                            <Link to="/ganhar-saldo/parceiros/catalogo-de-parceiros" className="linkStyleCustomBreadcrumbs">
                                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                                    <div className='txtNavListCustomBreadcrumbs'>Ver parceiros</div>
                                                </div>
                                            </Link>
                                        </>
                                    }
                                    { nomeparceiro.length !== 0 &&
                                        ( nomeparceiro.length > 15 ?
                                            <>
                                                <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                                    <div className='txtNavListCustomBreadcrumbs'>/</div>
                                                </div>
                                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                                    <div className='txtNavListCustomBreadcrumbs'>{handkeChangeMaxLength(nomeparceiro, 15)}</div>
                                                </div> 
                                                <div className='alertHoverInfoMainViewCustomBreadcrumbs'>
                                                    <div className='mainViewAlerSmModalCustomBreadcrumbs'>
                                                        <div className='CustomBreadcrumbs'>{nomeparceiro}</div>
                                                    </div>
                                                </div>
                                            </>
                                        : 
                                            <>
                                                <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                                    <div className='txtNavListCustomBreadcrumbs'>/</div>
                                                </div>
                                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                                    <div className='txtNavListCustomBreadcrumbs'>{nomeparceiro}</div>
                                                </div> 
                                            </>
                                        )
                                        
                                    }
                            </div>
                        </div>
                    )
                )
            }

           
            { ( hasBtnBack && !isMobileBtnBack ) &&
                <div className='goBackdMainViewContainerCustomBreadcrumbs'>
                    <div className='goBackBtnViewCustomBreadcrumbs'>
                        <button className='txtGoBackBtnCustomBreadcrumbs'  type='button' onClick={ goHome ? handleGoHomeClick : handleGoBackClick} >
                            <FaArrowLeftLong className='goBackIconCustomBreadcrumbs' /> Voltar
                        </button>
                    </div>
                </div>
            }
        </div>
    );
};

export default CustomBreadcrumbs;